import { Injectable } from '@angular/core';
import { ReadService } from './read.service';
import { HttpClient } from '@angular/common/http';
import { HttpResponsesHandlersFactory } from '../handlers/http-responses-handler';
import { MobileInformation } from '../interfaces/mobile-informations';

@Injectable({ providedIn: 'root' })
export class MobileInformationService extends ReadService<any, any> {
  url = '/api/mobileInformation';
  entityTitle = 'Mobile Information Service';

  constructor(http: HttpClient, handlersFactory: HttpResponsesHandlersFactory) {
    super(http, handlersFactory);
  }

  public getMobileInformationsViaOrganisationId(
    organisationId: number,
  ): Promise<MobileInformation[]> {
    return this.http
      .get<MobileInformation[]>(`${this.url}/organisation/${organisationId}`)
      .toPromise();
  }
}
